import { useEffect, useState } from "react";
import { api } from "../api";
import { PageHeader, Table, dt } from "../components/common";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const cols = [
    { key: "em", label: "Quando", render: (r) => dt(r.em) },
    { key: "ator_email", label: "Ator", render: (r) => <span className="font-semibold text-navy">{r.ator_email || "-"}</span> },
    { key: "acao", label: "Acao", render: (r) => <code className="text-xs bg-tint px-2 py-0.5 rounded">{r.acao}</code> },
    { key: "entidade", label: "Entidade" },
    { key: "entidade_id", label: "ID", render: (r) => <span className="text-xs text-muted2">{r.entidade_id}</span> },
  ];

  return (
    <div>
      <PageHeader overline="RGPD Art. 30" title="Auditoria" />
      <Table columns={cols} rows={rows} testid="audit-table" />
    </div>
  );
}
